module.exports = __webpack_public_path__ + "static/media/continental-finance-logo.293ea85c.png";